import React, { useEffect, useRef } from 'react';
export const OkendoWidgetClient = ({ dataAttributes, metafieldContent = '' }) => {
    const widgetContainer = useRef(null);
    const initializeWidget = () => {
        if (widgetContainer.current) {
            // `forceReinitialisation` must be true because we can expect `data-oke-rendered`
            // to be present on already-initialised widget snippets.
            window.okeWidgetApi.initWidget(widgetContainer.current, true);
        }
    };
    useEffect(() => {
        if (window.okeWidgetApi && widgetContainer.current) {
            initializeWidget();
        }
        else {
            document.addEventListener('oke-script-loaded', initializeWidget);
        }
        return () => {
            document.removeEventListener('oke-script-loaded', initializeWidget);
        };
    }, [dataAttributes]);
    return (React.createElement("div", { ref: widgetContainer, key: JSON.stringify(dataAttributes), ...dataAttributes, dangerouslySetInnerHTML: { __html: metafieldContent } }));
};
